import MarkerClusterer from '@googlemaps/markerclustererplus';

class EstateGoogleMap {
	constructor() {
		let $ = jQuery;
		let self = this;
		$( '.estate-map' ).each(function() {
			return self.initMap( $(this) );
		});
	}

	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	initMap( $el ) {
		let $ = jQuery;
		// Find marker elements within map.
		let $markers = $el.find('.marker');

		// Removes points of intrest from the map
		let removeDefaultLabels = [
			{
				featureType: "poi",
				elementType: "labels",
				stylers: [
						{ visibility: "off" }
				]
			}
		];

		// Create generic map.
		let mapArgs = {
			zoom        : 8,
			center: { lat: 55.4638728, lng: 13.5177139 },
			mapTypeId   : google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			styles: removeDefaultLabels,
		};

		let map = new google.maps.Map( $el[0], mapArgs);
		let infowindow = new google.maps.InfoWindow();
		const locations = [];

		// Get data attributes from each marker
		$markers.each(function() {
			locations.push({
				lat: $(this).data('lat'),
				lng: $(this).data('lng'),
				icon: $(this).data('icon'),
				name: $(this).data('name'),
				municipality: $(this).data('municipality'),
				tax: $(this).data('tax'),
				img: $(this).data('img'),
				link: $(this).data('link'),
			});
		});

		// Create markers on map
		const mapMarkers = locations.map(location => {
			let marker = new google.maps.Marker({
				position: { lat: location.lat, lng: location.lng },
				icon: location.icon,
				name: location.name,
				municipality: location.municipality,
				tax: location.tax,
				img: location.img,
				link: location.link
			});

			// For each marker, create a infowindow
			google.maps.event.addListener(marker, 'click', (function (marker) {
                return function () {
                    infowindow.setContent(`
						<a href="${marker.link}" class="info-window">
							<img src="${marker.img}" class="img-fluid">
							<div class="content">
								<h1>${marker.name} - ${marker.municipality}</h1>
								<p>${marker.tax}</p>
							</div>
						</a>
					`);
					if (!marker.open) {
						infowindow.open(map, marker);
						marker.open = true;
					} else {
						infowindow.close();
						marker.open = false;
					}
					google.maps.event.addListener(map, 'click', function() {
						infowindow.close();
						marker.open = false;
					});
                }
            })(marker));

			return marker;
		});

		// Add a marker clusterer to manage the markers.
		new MarkerClusterer(map, mapMarkers, {
			imagePath: `${wpurl.site}/assets/dist/images/marker-cluster`,
		});

		return map;
	}
}

export default EstateGoogleMap;
